import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { configure } from "mobx";

import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

configure({
  enforceActions: "never",
});

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    min-height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-grow: 1;
  }

  * {
    box-sizing: border-box;
  }
`;

render(
  <BrowserRouter>
    <GlobalStyle />
    <App />
  </BrowserRouter>,
  document.getElementById("root"),
);

reportWebVitals();
